import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const navigation = [
    { name: 'Home', href: '/', current: false },
    { 
        name: 'Services', 
        href: '/services',
        current: false 
    },
    { name: 'Who We Are', href: '/about', current: false },
    { name: 'Contact', href: '/contact', current: false },
];

const Drawerdata = () => {
    const location = useLocation();

    return (
        <div className="flex flex-col space-y-6">
            {/* Navigation Links */}
            <nav className="flex flex-col space-y-4">
                {navigation.map((item) => (
                    <Link
                        key={item.name}
                        to={item.href}
                        className={`text-lg font-medium px-4 py-2 rounded-lg transition-colors duration-300 ${
                            location.pathname === item.href
                            ? 'bg-[#052c65] text-white'
                            : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        {item.name}
                    </Link>
                ))}
            </nav>

            {/* Contact Section */}
            <div className="border-t border-gray-200 pt-6">
                <Link
                    to="/contact"
                    className="block bg-[#29abe2] text-white px-6 py-3 rounded-lg hover:bg-[#052c65] transition duration-300 text-center"
                >
                    <div className="text-sm font-medium">Get in Touch</div>
                    <div className="text-lg font-semibold">(562) 618-4677</div>
                </Link>
            </div>
        </div>
    );
};

export default Drawerdata; 